import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import SlideToggle from 'react-slide-toggle';
import { compose } from 'redux'
import { filterDefault, closeDefault } from '../../common/MangoIcons'

import { getBrandFilters, getColourFilters, getGenderFilters, getRangeFilters } from "../../../actions/filters"

class Filter extends Component {

    constructor() {
        super();
        this.state = {
            openFilter: false,
            toggleBrand:true,
        toggleCategory : true,
        toggleSize : true,
        toggleColor : true,
        toggleRange : true,
        togglePurity:true,

            selectedBrands: [],
            selectedPurities:[],
            selectedSizes: [],
            selectedColors: [],
            selectedCategories:[],
            selectedGenders: [],
            value: { min: 0, max: 999999 }
        }
    }

    componentDidMount(){
        const { connection_id } = this.props;


    }
    componentWillReceiveProps(nextProps) {
        
        
        const { connection_id, store_id } = this.props;
        if (nextProps.match.params.id !== this.props.match.params.id) {
            const category_id = nextProps.match.params.id;
           // 
            this.setState({
                selectedBrands: [],
                selectedSizes: [],
                selectedPurities:[],
                selectedColors: [],
                selectedCategories:[],
                selectedGenders: [],
                value: { min: 0, max: 999999 }
            })
        }
        if (nextProps.store_id !== this.props.store_id) {
            const { category_id } = this.props;
            this.setState({
                selectedBrands: [],
                selectedSizes: [],
                selectedPurities:[],
                selectedColors: [],
                selectedCategories:[],
                selectedGenders: [],
                value: { min: 0, max: 999999 }
            })

        }
    }

    closeFilter = () => {
        document.querySelector(".collection-filter").style = "left: -365px";
    }

    onBrandToggle = () => {
        
        // this.props.getBrandFilters(this.props.connection_id);
    };

    onGenderToggle = () => {
        // this.props.getGenderFilters(this.props.connection_id);
    };

    resetFilters = () => {
        this.setState({
            selectedBrands: [],
            selectedSizes: [],
             selectedPurities:[],
            selectedColors: [],
            selectedCategories:[],
            selectedGenders: [],
            value: { min: 0, max: 999999 }
        }, () => {

            this.props.handleApplyFilters(this.state)
        })
    }

    onRangeToggle = () => {
        const options = {
            connection_id: this.props.connection_id,
            category_id: this.props.categoryId,
            brand_code: this.state.selectedBrands
        }
        // this.props.getRangeFilters(options);
    };

    onColorToggle = () => {
        //this.props.getColourFilters(this.props.connection_id);
    };
    handleToggle (){
         this.setState({
            toggleBrand: true,
            toggleCategory : false,
            toggleSize : false,
            togglePurity:false,
            toggleColor : false,
            toggleRange : false,

         })
         localStorage.removeItem('category_name')
        localStorage.setItem('toggleCat',true)
       
    }
    handleCatToggle(){
        this.setState({
            toggleCategory : true,
            toggleBrand : false,
            toggleSize : false,
            togglePurity:false,

            toggleColor : false,
            toggleRange : false,

         })
         localStorage.removeItem('category_name')
    }

    handleSizeToggle(){
        this.setState({
            toggleCategory : false,
            toggleBrand : false,
            toggleSize : true,
            toggleColor : false,
            toggleRange : false,
            togglePurity:false,

         })
         localStorage.removeItem('category_name')
    }
    handlePurityToggle(){
        this.setState({
            toggleCategory : false,
            toggleBrand : false,
            toggleSize : false,
            togglePurity:true,
            toggleColor : false,
            toggleRange : false,

         })
         localStorage.removeItem('category_name')
    }
    handleColorToggle(){
        this.setState({
            toggleCategory : false,
            toggleBrand : false,
            toggleSize : false,
            togglePurity:false,

            toggleColor : true,
            toggleRange : false,

         })
         localStorage.removeItem('category_name')
         var elmnt = document.getElementById("collection-filter-block");
         elmnt.scrollTop =200;
    }
    handleRangeToggle(){
        this.setState({
            toggleCategory : false,
            toggleBrand : false,
            toggleSize : false,
            togglePurity:false,

            toggleColor : false,
            toggleRange : true,

         })
         localStorage.removeItem('category_name')
         var elmnt = document.getElementById("collection-filter-block");
         elmnt.scrollTop =300;
    }
  
  clickBrandHandle = (event) => {

    const selectedBrand = event.target.id;
    this.setState({
        selectedSizes: [],
                selectedPurities:[],
                selectedColors: [],
                
                value: { min: 0, max: 999999 }
    })

    this.setState((prevState) => ({
        selectedBrands:
            prevState.selectedBrands[0] === selectedBrand
                ? []
                : [selectedBrand]
    }), () => {
        if (this.props.sideBarOption !== 'No') {
            this.props.handleApplyFilters(this.state);
        }
    });
};

    clickGenderHandle = (event) => {
        // event.preventDefault();
        if (event.target.id === this.state.selectedGenders) {
            this.setState({ selectedGenders: '' },
                () => {
                    // 
                   // this.props.handleApplyFilters(this.state)
                })
        }
        else {
            this.setState({ selectedGenders: event.target.id },
                () => {
                    // 
                    // this.props.handleApplyFilters(this.state)
                })
        }
    }

    clickColourHandle = (event) => {
        // event.preventDefault();
        //  if(event.target.id === this.state.selectedColors){
        //      this.setState({ selectedColors: '' },
        //          () => {
        //              // 
        //              this.props.handleApplyFilters(this.state)
        //          })
        //  }
        //  else{
        //  this.setState({ selectedColors: event.target.id },
        //      () => {
        //          // 
        //          this.props.handleApplyFilters(this.state)
        //      })
        //  }
        const selected = this.state.selectedColors;
        this.props.colours.map(color => {
            if (color.SKU_VARIANT1_VALCD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {

                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedColors: selected },
                    () => {
                        // Directly call filter api
                       this.props.sideBarOption !== 'No' && 
                       this.props.handleApplyFilters(this.state)
                    })
            }
            else return null
        })
    }

    clicksizeHandle = (event) => {
        const selected = this.state.selectedSizes;
        this.props.sizes.map(size => {
            if (size.SKU_VARIANT2_VALCD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {
                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedSizes: selected },
                    () => {
                        // Directly call filter api
                        this.props.sideBarOption !== 'No' &&
                        this.props.handleApplyFilters(this.state)
                    })
            }
            else return null
        })
    }
    clickPurityHandle = (event) => {
        const selected = this.state.selectedPurities;
        this.props.purities.map(purity => {
            if (purity.SKU_VARIANT4_VALCD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {
                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedPurities: selected },
                    () => {
                        // Directly call filter api
                        this.props.sideBarOption !== 'No' &&
                        this.props.handleApplyFilters(this.state)
                    })
            }
            else return null
        })
    }


    clickPriceRangeHandle = (sideBarOption) => {
        // Price range filter
        sideBarOption !== 'No' && this.props.handleApplyFilters(this.state)
    }
    clickcatHandle = (event,cname) => {
        localStorage.setItem('category_name',cname)
        const { connection_id } = this.props
        if (event.target.id === this.state.selectedCategories) {
            this.setState({ selectedCategories: '' }, () => {
                this.resetFilters()
            })

        }
        else {
            this.resetFilters()
            this.setState({ selectedCategories: event.target.id },
                () => {
                  
                    this.props.handleApplyFilters(this.state)
                })
        }
    }



    colorHandle(event, color) {
        // var elems = document.querySelectorAll(".color-selector ul li");
        // [].forEach.call(elems, function(el) {
        //     el.classList.remove("active");
        // });
        // event.target.classList.add('active');
        // this.props.filterColor(color)
    }

    render() {
        // const filteredBrands = this.props.filters.brands;
        const { brandLoading, brands, loading, genders, genderLoading, categories,ranges, rangeLoading, colorLoading, colours, sizesLoading, sizes,purities, sideBarOption,puritiesLoading,store_details,dataLoad } = this.props
        const { selectedBrands, selectedGenders, selectedColors, selectedSizes,selectedPurities,selectedCategories } = this.state
        if (loading) {
            return (
                <div style={{ 'marginTop': '50vh' }}>
                    <div className="loading-cls"></div>
                </div>
            )
        }
        return (
            <>
                <div className="" style={window.innerWidth > 789 ? {width:250,position:'fixed'}: {}}>
                    {/*brand filter start*/}
                    <div className="filter-header">
                        <img src={filterDefault} style={{marginLeft: 10}}/>
                        <span className="left-side">Filter</span>
                        {sideBarOption === 'No'&&
                        <img src={closeDefault} className="right-side" onClick={() => this.props.onSetSidebarOpen(false)} />
                        }
                    </div>
                    <div className={"collection-filter-block"} id='collection-filter-block' style={window.innerWidth < 789 ? {marginTop:50,height:300}:{height:250}}>
                        <SlideToggle
                    collapsed={true}
                >
                     
                    {({toggle, setCollapsibleElement }) => (
                        <div className="collection-collapse-block" onClick={()=>this.handleToggle()}>
                            <h3 className="collapse-block-title" onClick={toggle}>brand{selectedBrands.length > 0 ? `(${selectedBrands.length})` : ""}</h3>
                            <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                <div className="collection-brand-filter">
                                    {brandLoading ? <div className="loading-cls"></div> :
                                        brands.map((brand, index) => {
                                            return (
                                                this.state.toggleBrand &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                           <label  htmlFor={brand.BRD_CD} onChange={(e)=>this.clickBrandHandle(e)}>
                                                            <input className="checkbox_animated" type="checkbox" id={brand.BRD_CD} name={brand.BRD_CD}
                                                              checked={selectedBrands.includes(brand.BRD_CD) ? true : false} />
                                                               
                                                            {/* checked={selectedBrands === brand.BRD_CD ? true : false} /> */}
                                                            {brand.BRD_NAME}
                                                        </label> 
                                                </div>
                                                )
                                        })}
                                </div>
                            </div>
                        </div>
                    )}
                </SlideToggle> 
                        {/*gender filter start here*/}
                        {/* <SlideToggle
                    onExpanded={() => {
                        if (!!genders && genders.length <= 0) {
                            this.onGenderToggle()
                        }
                    }}
                    collapsed
                    >
                    {({toggle, setCollapsibleElement }) => (
                        <div className="collection-collapse-block">
                            <h3 className="collapse-block-title"  onClick={toggle}>Purity</h3>
                            <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                <div className="collection-brand-filter">
                                    {genderLoading ? <div className="loading-cls"></div> :
                                        genders.map((gender, index) => {
                                            return (
                                                <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                        <label  htmlFor={gender.GEN_GENDER_CD} onChange={this.clickGenderHandle}>
                                                            <input className="checkbox_animated" type="checkbox" id={gender.GEN_GENDER_CD} name={gender.GEN_GENDER_CD}
                                                            //  checked={selectedgenders.includes(gender.GEN_GENDER_CD) ? true : false} />
                                                            checked={selectedGenders === gender.GEN_GENDER_CD ? true : false} />
                                                            {gender.GEN_GENDER_NAME}
                                                        </label> 
                                                </div>
                                                )
                                        })}
                                </div>
                            </div>
                        </div>
                    )}
                    </SlideToggle>       */}


{/* commited category dropdown */}

{/* <SlideToggle
                             collapsed={true}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block" onClick={()=>this.handleCatToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Category {selectedCategories.length > 0 ? "(1)" : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {brandLoading ? <div className="loading-cls"></div> :
                                                categories.map((cat, index) => {
                                                   var cat_id =cat.SMH_LEVEL5_CD !== null ? 
                                                   cat.SMH_LEVEL5_CD : 
                                                   cat.SMH_LEVEL4_CD !== null ? 
                                                   cat.SMH_LEVEL4_CD : 
                                                   cat.SMH_LEVEL3_CD !== null ? 
                                                   cat.SMH_LEVEL3_CD : 
                                                   cat.SMH_LEVEL2_CD;
                                                    return (
                                                        this.state.toggleCategory &&  <div className="custom-control collection-filter-checkbox"  key={index}>
                                                            <label htmlFor={cat_id} onChange={(e) => this.clickcatHandle(e,cat.SMH_LEVEL3_DESC)} style={{textAlignLast:'center'}}>
                                                                <input className="radio_animated" type="radio" id={cat_id} name={cat_id}
                                                                    //  checked={selectedcats.includes(cat_id) ? true : false} />
                                                                    checked={selectedCategories === cat_id ? true : false} />
                                                                {cat.SMH_LEVEL3_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div> 
                                </div>
                            )}
                        </SlideToggle> */}
                        {/*size filter start here*/}
                        <SlideToggle
                            // collapsed={sideBarOption === 'No' ? true : false}
                            collapsed={true} 
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className={selectedBrands && selectedBrands.length == 0 || dataLoad  ? 'disabledFilter collection-collapse-block':"collection-collapse-block"} onClick={()=>this.handleSizeToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Size {selectedSizes.length > 0 ? `(${selectedSizes.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {sizesLoading ? <div className="loading-cls"></div> :
                                                sizes.map((size, index) => {
                                                    return (
                                                        this.state.toggleSize && <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={size.SKU_VARIANT2_VALCD} onChange={(e) => this.clicksizeHandle(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={size.SKU_VARIANT2_VALCD} name={size.SKU_VARIANT2_VALUE_DESC}
                                                                    checked={selectedSizes.includes(size.SKU_VARIANT2_VALCD) ? true : false}
                                                                />
                                                                {size.SKU_VARIANT2_VALUE_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        {/* purity */}
                        { store_details && store_details.tenant_name == 'Goldiam International Limited' ?

                        <SlideToggle
                            // collapsed={sideBarOption === 'No' ? true : false}
                            collapsed={true} 
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className={selectedBrands && selectedBrands.length == 0 || dataLoad ? 'disabledFilter collection-collapse-block':"collection-collapse-block"} onClick={()=>this.handlePurityToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Purity {selectedPurities.length > 0 ? `(${selectedPurities.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {puritiesLoading ? <div className="loading-cls"></div> :
                                                purities.map((purity, index) => {
                                                    return (
                                                        this.state.togglePurity && <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={purity.SKU_VARIANT4_VALCD} onChange={(e) => this.clickPurityHandle(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={purity.SKU_VARIANT4_VALCD} name={purity.SKU_VARIANT2_VALUE_DESC}
                                                                    checked={selectedPurities.includes(purity.SKU_VARIANT4_VALCD) ? true : false}
                                                                />
                                                                {purity.SKU_VARIANT4_VALUE_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle> : '' }

                        <SlideToggle
                            collapsed={true}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className={selectedBrands && selectedBrands.length == 0 || dataLoad? 'disabledFilter collection-collapse-block':"collection-collapse-block"} onClick={()=>this.handleColorToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Color {selectedColors.length > 0 ? `(${selectedColors.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {colorLoading ? <div className="loading-cls"></div> :
                                                colours.map((colour, index) => {
                                                    return (
                                                        this.state.toggleColor &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={colour.SKU_VARIANT1_VALCD} onChange={(e) => this.clickColourHandle(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={colour.SKU_VARIANT1_VALCD} name={colour.SKU_VARIANT1_VALUE_DESC}
                                                                    checked={selectedColors.includes(colour.SKU_VARIANT1_VALCD) ? true : false}
                                                                />
                                                                {colour.SKU_VARIANT1_VALUE_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>

                        <SlideToggle
                             onExpanded={() => {
                            //     if (!!ranges && ranges.length <= 0) {
                            //         this.onRangeToggle()
                            //     }
                           // collapsed=true
                             }}
                             onClick={console.log()}
                            collapsed={true}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                               
                                // <div className={selectedBrands === "" ? 'disabledFilter collection-collapse-block': 'collection-collapse-block'}>
                                <div className={selectedBrands && selectedBrands.length == 0 || dataLoad ?  'disabledFilter collection-collapse-block': 'collection-collapse-block'} onClick={()=>this.handleRangeToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Price Range</h3>
                                    <div className="collection-collapse-block-content block-price-content" ref={setCollapsibleElement}>
                                    {ranges.length > 0 ||Object.keys(ranges).length > 0?  
                                        <div className="collection-brand-filter">
                                            {rangeLoading ? <div className="loading-cls"></div> : 
                                           
                                           this.state.toggleRange && <div className="custom-control custom-checkbox collection-filter-checkbox">
                                                   
                                                   
                                                   <InputRange
          maxValue={parseInt(ranges.MAX_LOT_PRICE) || null}
          minValue={parseInt(ranges.MIN_LOT_PRICE) || null}
          value={this.state.value}
          onChange={value => this.setState({ value })}
         onChangeComplete={()=>this.clickPriceRangeHandle(sideBarOption)}
           /> 
                                                </div>
                                                
                                            }
                                        </div>
                                         : '' }
                                    </div>
                                </div>
                            )}
                        </SlideToggle>


                    </div>
                </div>
                {sideBarOption === 'No' &&
                <div className=" row filter-bottom" >

                    <div className="col-sm text-center" style={{paddingBottom:10}} onClick={() => this.resetFilters()}>

                        <button type="submit" className="btn btn-solid" style={{ width: "100%" }}>Remove Filter</button>
                    </div>
                    <div className="col-sm text-center" style={{padding:10}} onClick={() => this.props.handleApplyFilters(this.state)}>

                        <button type="submit" className="btn btn-solid" style={{ width: "100%" }}>Apply Filter</button>
                    </div>

                </div>
                }
            </>
        )
    }
}


const mapStateToProps = state => ({
    brands: state.filters.brand.data,
    brandLoading: state.filters.brand.loading,
    genders: state.filters.gender.data,
    genderLoading: state.filters.gender.loading,
    ranges: state.filters.range.data,
    rangeLoading: state.filters.range.loading,
    colours: state.filters.colour.data || [],
    colourLoading: state.filters.colour.loading,
    sizes: state.filters.size.data || [],
    purities: state.filters.purity.data || [],
    sizesLoading: state.filters.size.loading,
    puritiesLoading: state.filters.purity.loading,
    categories: state.filters.categories.data || [],
    categoriesLoading: state.filters.categories.loading,
    store_details: state.tenant.store_details,
    // colors: getColors(state.data.products),
    // prices: getMinMaxPrice(state.data.products),
    filters: state.filters,
    connection_id: state.tenant.connection_id,
    loading: state.filters.loading,
})


export default compose(
    withRouter,
    connect(
        mapStateToProps,
        { getBrandFilters, getColourFilters, getGenderFilters, getRangeFilters }
    ))
    (Filter);